import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from 'antd';
import './RDCheckbox.scss';

const RDCheckbox = ({ onChange, checkboxLabel, isChecked, isDisabled }) => (
  <Checkbox onChange={onChange} checked={isChecked} disabled={isDisabled}>
    {checkboxLabel}
  </Checkbox>
);

RDCheckbox.defaultProps = {
  isChecked: false,
  isDisabled: false,
  onChange: () => {},
  checkboxLabel: '',
};

RDCheckbox.propTypes = {
  /** Checkbox label */
  checkboxLabel: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
  /** The callback function that is triggered when the state changes */
  onChange: PropTypes.func,
  /** Specifies whether the checkbox is selected */
  isChecked: PropTypes.bool,
  /** Disabled state of checkbox */
  isDisabled: PropTypes.bool,
};

export default RDCheckbox;
